<div class="filing-checklist-icon-container">
  <div
    class="filing-checklist-icon"
    [ngClass]="(isValid$ | async) === false ? 'invalid' : ''"
    (click)="onChecklistIconClicked()"
  ></div>
</div>
